import { render, staticRenderFns } from "./auto_excel_upDetail.vue?vue&type=template&id=71561f84&scoped=true"
import script from "./auto_excel_upDetail.vue?vue&type=script&lang=js"
export * from "./auto_excel_upDetail.vue?vue&type=script&lang=js"
import style0 from "./auto_excel_upDetail.vue?vue&type=style&index=0&id=71561f84&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "71561f84",
  null
  
)

export default component.exports